<template>
    <ul class="flex gap-1 items-center">
        <li v-for="(link, index) of links">
            <Link :href="link.url"
                  class="rounded-full w-8 h-8 text-2xl flex items-center justify-center block transition-colors"
                  :class="[getActiveStyles(link)]">

                <FontAwesomeIcon v-if="index === 0" icon="angle-left"></FontAwesomeIcon>

                <FontAwesomeIcon v-else-if="index === (links.length - 1)" icon="angle-right"></FontAwesomeIcon>

                <template v-else>{{ link.label }}</template>
            </Link>
        </li>
    </ul>
</template>
<script setup>
import {Link} from "@inertiajs/inertia-vue3";
import {computed} from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const props = defineProps({
    links: Array
});


function getActiveStyles(link) {
    if (link.active) {
        return ["bg-primary", "text-white"];
    } else {
        return ["bg-white", "text-dark", "hover:bg-grey-100"];
    }
}
</script>
